import { render, staticRenderFns } from "./MonitoringMatrixBlock.vue?vue&type=template&id=06fd3695&scoped=true&"
import script from "./MonitoringMatrixBlock.vue?vue&type=script&lang=js&"
export * from "./MonitoringMatrixBlock.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringMatrixBlock.vue?vue&type=style&index=0&id=06fd3695&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd3695",
  null
  
)

export default component.exports